var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconFinancialOverview = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.828,
    height: 49,
    viewBox: "0 0 49.828 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "statistic-up",
    transform: "translate(-22 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6462",
    "data-name": "Group 6462",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11697",
    "data-name": "Path 11697",
    d: "M24,24V64a5,5,0,0,0,5,5H69",
    transform: "translate(-24 -24)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5.759,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11698",
    "data-name": "Path 11698",
    d: "M56,79,66,69,76,79,91,64",
    transform: "translate(-46 -51.5)",
    fill: "none",
    stroke: "#f69139",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5.759,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11699",
    "data-name": "Path 11699",
    d: "M144,64h7.5v7.5",
    transform: "translate(-106.5 -51.5)",
    fill: "none",
    stroke: "#f69139",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFinancialOverview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-financial-overview.b4423fb9.svg";
export { ForwardRef as ReactComponent };